import {Injectable} from '@angular/core';
import {AbstractSessionParametersLoaderService} from '../../parameters/services/abstract-session-parameters-loader.service';
import {ArchetypeDecisionParameters} from './archetype-decision-parameters.model';

@Injectable({
    providedIn: 'root'
})
export class ArchetypeDecisionParametersLoaderService extends AbstractSessionParametersLoaderService<ArchetypeDecisionParameters> {

    constructor() {
        super('archetypes')
    }
}
